import { render, staticRenderFns } from "./CardProfissional.vue?vue&type=template&id=8eac32a4&scoped=true&"
import script from "./CardProfissional.vue?vue&type=script&lang=js&"
export * from "./CardProfissional.vue?vue&type=script&lang=js&"
import style0 from "./CardProfissional.vue?vue&type=style&index=0&id=8eac32a4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8eac32a4",
  null
  
)

/* vuetify-loader */
import installComponents from "!../../../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VImg } from 'vuetify/lib/components/VImg';
installComponents(component, {VCard,VImg})


/* hot reload */
if (module.hot) {
  var api = require("D:\\Trabalho\\Lupa Soluções em TI\\Clientes\\Leonardo Raton\\Site\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('8eac32a4')) {
      api.createRecord('8eac32a4', component.options)
    } else {
      api.reload('8eac32a4', component.options)
    }
    module.hot.accept("./CardProfissional.vue?vue&type=template&id=8eac32a4&scoped=true&", function () {
      api.rerender('8eac32a4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/pages/SelecaoAssinatura/components/cards/acessor/CardProfissional.vue"
export default component.exports